import { defineComponent as _defineComponent } from 'vue'
import { DetailedViewEnum, WidgetEnum } from '@/models/enums/WidgetEnum';
import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';
import WidgetFactory from '@/models/Charts/widgetFactory';
import { CumulativeLinesGenerator } from '@/models/Charts/cumulativeLinesGenerator';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { isEmpty } from '@/utils/misc';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { CuttingTimePerGasData } from '@/models/Charts/chartsData';
import { ChartGenerator } from '@/models/Charts/abstract/chartGenerator';
import { customersService } from '@/services/tenants.service';
import { computed, onBeforeUnmount, onMounted, ref, shallowRef } from 'vue';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'CutIntraday',
  props: {
    widgetDefinition: null,
    selectedDeviceIds: null,
    selectedShifts: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  widgetDefinition: WidgetDefinition;
  selectedDeviceIds: string[];
  selectedShifts: number[];
};





const { t } = useI18n();

const gasWidget = ref<DetailedViewEnum>(
  props.widgetDefinition.widget === WidgetEnum.LaserCuttingTime
    ? DetailedViewEnum.LaserTodaysGas
    : DetailedViewEnum.TubesCuttingTimePerGas,
);
const cumulativeWidget = ref<DetailedViewEnum>(
  props.widgetDefinition.widget === WidgetEnum.LaserCuttingTime
    ? DetailedViewEnum.CumulativeCuttingTime
    : DetailedViewEnum.TubesCumulativeCuttingTime,
);
const cumulativeShiftsWidget = ref<DetailedViewEnum>(
  props.widgetDefinition.widget === WidgetEnum.LaserCuttingTime
    ? DetailedViewEnum.CumulativeCuttingTimePerShift
    : DetailedViewEnum.TubesCumulativeCuttingTimePerShift,
);

const customerIdDh = computed<number>(
  () => customersService.store.currentIdDh()!,
);

const gasGen: ChartGenerator<CuttingTimePerGasData[]> =
  WidgetFactory.createGenerator(gasWidget.value, customerIdDh.value);
const cumulativeGen: ChartGenerator<any[]> = WidgetFactory.createGenerator(
  cumulativeWidget.value,
  customerIdDh.value,
);
const cumulativeShiftsGen: CumulativeLinesGenerator =
  WidgetFactory.createGenerator(
    cumulativeShiftsWidget.value,
    customerIdDh.value,
  ) as CumulativeLinesGenerator;

const cumulativeLoaded = ref(false);
const cumulativeShiftsLoaded = ref(false);
const gasLoaded = ref(false);

const cumulativeOptions: any = shallowRef({});
const cumulativeShiftsOptions: any = shallowRef({});
const gasOptions: any = shallowRef({});

const thereIsCumulativeInfo = ref(false);
const thereIsCumulativeShiftsInfo = ref(false);
const thereIsGasInfo = ref(false);

onMounted(async () => {
  await update();
});

async function update() {
  gasGen
    .getData(
      props.selectedDeviceIds,
      props.selectedShifts,
      FilterTimeSpanEnum.Day,
    )
    .then((gasData: CuttingTimePerGasData[] | null) => {
      if (!isEmpty(gasData)) {
        thereIsGasInfo.value = gasData!.some((d) => d.cutting_time > 0);
        const params = WidgetFactory.createOptions(gasWidget.value);
        gasOptions.value = gasGen.updateOptions(gasData!, params);
      }
      gasLoaded.value = true;
    });

  cumulativeGen
    .getData(
      props.selectedDeviceIds,
      props.selectedShifts,
      FilterTimeSpanEnum.Day,
      FilterTimeAxisSpanEnum.None,
    )
    .then((cumulativeData: any[] | null) => {
      thereIsCumulativeInfo.value = !isEmpty(cumulativeData);
      if (thereIsCumulativeInfo.value) {
        const params = WidgetFactory.createOptions(cumulativeWidget.value);
        cumulativeOptions.value = cumulativeGen.updateOptions(
          cumulativeData!,
          params,
        );
      }
      cumulativeLoaded.value = true;
    });

  cumulativeShiftsGen
    .getData(props.selectedDeviceIds, props.selectedShifts)
    .then((cumulativeShiftsData) => {
      thereIsCumulativeShiftsInfo.value = !isEmpty(cumulativeShiftsData);
      if (thereIsCumulativeShiftsInfo.value) {
        const params = WidgetFactory.createOptions(
          cumulativeShiftsWidget.value,
        );
        cumulativeShiftsOptions.value = cumulativeShiftsGen.updateOptions(
          cumulativeShiftsData!,
          params,
        );
      }
      cumulativeShiftsLoaded.value = true;
    });
}

onBeforeUnmount(() => {
  gasGen?.abort();
  cumulativeGen?.abort();
  cumulativeShiftsGen?.abort();
});

return { __sfc: true,props, emit, t, gasWidget, cumulativeWidget, cumulativeShiftsWidget, customerIdDh, gasGen, cumulativeGen, cumulativeShiftsGen, cumulativeLoaded, cumulativeShiftsLoaded, gasLoaded, cumulativeOptions, cumulativeShiftsOptions, gasOptions, thereIsCumulativeInfo, thereIsCumulativeShiftsInfo, thereIsGasInfo, update }
}

})